import jwtDecode from 'jwt-decode';

import { baseURL } from 'app/api';
import { startEarlyRequests } from 'app/earlyRequests';
import { preloadPage } from 'app/pages/preload';
import { NewNavbar } from 'app/components/NewNavbar/Loadable';
import { INITIAL_CLIENT_PAGE_SIZE } from 'app/pages/Inbox/slice/saga';
import { getActiveToken } from 'utils/tabAuth';
import { isEmbedPath } from 'utils/embedBoot';
import { getDomainConfig } from 'utils/whiteLabel';

// Imported first by index.tsx. A saved, unexpired login means the dashboard is
// about to open, so its page file and its first reads start now, alongside
// React mounting, rather than after each screen has rendered and asked.
// The paths are the ones the Auth and Inbox sagas request; a path that drifts
// only loses the head start.
const startDashboardEarly = (): void => {
  const token = getActiveToken();
  const { pathname, search } = window.location;
  if (
    !token ||
    isEmbedPath(pathname) ||
    pathname.startsWith('/docs') ||
    search.includes('auth_token=') ||
    getDomainConfig().isPartnerDashboard
  )
    return;

  let login: { exp?: number; business?: { id?: number } };
  try {
    login = jwtDecode(token);
  } catch {
    return;
  }
  if (!login.business?.id || !login.exp || Date.now() >= login.exp * 1000)
    return;

  NewNavbar.preload();
  preloadPage(pathname);

  const reads = ['/business', '/role-permission', '/org/memberships'];
  if (pathname === '/' || pathname === '/inbox')
    reads.push(`/clients?limit=${INITIAL_CLIENT_PAGE_SIZE}`);
  startEarlyRequests(baseURL, reads);
};

startDashboardEarly();
